import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Modal,
  Typography,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import CartCard from "./components/CartCard/CartCard";
import CarOrderForm from "./components/CartForm";
import "./Cart.css"; // Import the external CSS file
import { useNavigate } from "react-router-dom";
import { setCartList } from "./sliceCart";

const Cart = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { cartList } = useSelector((state) => state.sliceCart);
  const [openModal, setOpenModal] = useState(false);

  const handleClearCart = () => {
    setOpenModal(true);
  };

  const confirmClearCart = () => {
    dispatch(setCartList([]));
    setOpenModal(false);
  };

  // Calculate the sum of NetAmount
  const totalNetAmount = cartList?.reduce(
    (sum, product) => sum + (product.NetAmount || 0),
    0
  );

  return (
    <Container
      maxWidth="lg"
      className="container"
      sx={{ marginTop: { xs: 18, sm: 20, md: 3 } }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        mb={2}
        sx={{ width: "100%" }}
      >
        <Button
          type="button"
          variant="contained"
          size="small"
          onClick={() => navigate("/mposordertaking")}
          sx={{
            width: "fit-content",
          }}
        >
          Back
        </Button>
        <Button
          type="button"
          variant="contained"
          color="error"
          size="small"
          onClick={handleClearCart}
          sx={{
            ml: 1,
            width: "fit-content",
          }}
        >
          Clear Cart
        </Button>
        &nbsp;
      </Box>
      <Grid
        container
        spacing={{ xs: 0.5 }}
        justifyContent="space-between"
        className="gridContainer"
      >
        <Grid item xs={12} md={8.5}>
          <Typography
            variant="h3"
            sx={{
              textAlign: "center",
              marginBottom: 1,
              fontWeight: "bold",
              display: "inline-block",
            }}
          >
            Cart
          </Typography>
          <Grid
            container
            spacing={1}
            className={`cartList `}
            sx={{ height: { xs: "33vh", md: `${cartList?.length > 4 ? "70vh" : "auto"}` } }}
          >
            {cartList &&
              cartList?.length > 0 &&
              cartList?.map((product, index) => (
                <Grid
                  item
                  xs={12}
                  key={index}
                  sx={{ width: "100%", paddingLeft: "0 !important" }}
                >
                  <CartCard product={product} cartList={cartList} />
                  <Divider light />
                </Grid>
              ))}
            {/* Display Total NetAmount */}
            {cartList?.length > 0 && (
              <Box
                mt={2}
                sx={{
                  display: "flex",
                  justifyContent: "end",
                  paddingRight: 2,
                  width: "inherit",
                }}
              >
                <Typography variant="h6" sx={{ fontSize: "1rem", fontWeight: "bolder" }}>
                  Total : {totalNetAmount.toFixed(2)} AED
                </Typography>
              </Box>
            )}
          </Grid>
        </Grid>
        <Grid item xs={12} md={3.5}>
          <Typography
            variant="h3"
            sx={{
              textAlign: "center",
              marginBottom: 1,
              fontWeight: "bold",

              display: "inline-block",
            }}
          >
            Customer Information
          </Typography>
          <CarOrderForm />
        </Grid>
      </Grid>
      {/* Confirmation Modal */}
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 3,
            width: 300,
            textAlign: "center",
          }}
        >
          <Typography variant="h6" mb={2}>
            Confirm Clear Cart
          </Typography>
          <Typography variant="body2" mb={3}>
            Are you sure you want to clear all items from the cart?
          </Typography>
          <Box display="flex" justifyContent="space-around">
            <Button
              variant="contained"
              color="error"
              onClick={confirmClearCart}
            >
              Yes
            </Button>
            <Button variant="outlined" onClick={() => setOpenModal(false)}>
              No
            </Button>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default Cart;
